export default {
    version: "0.0.1",
    demo_account: {
        user: {
            availability_hours: null,
            avatar: "",
            connectors: [],
            days_off: [],
            days_off_message: "Je suis actuellement en congés et serai de retour prochainement. N'hésitez pas à me rappeler à mon retour.",
            email: "john.doe@leedflow.com",
            email_authentication: "john.doe@leedflow.com",
            email_domain: "leedflow.com",
            emails: {
                activities: false,
                news: false,
                prospect_interest: false
            },
            fcm: [],
            firstname: "John",
            id_subscription: {},
            last_login: null,
            lastname: "Doe",
            legal_entity: false,
            partner_system: "",
            partner_uid: "",
            phone: "33700000000",
            phone_display_type: "personal",
            position: "Démonstrateur Leedflow",
            voip_enabled: false,
            recording_announcement_enabled: true,
            role: "customer",
            voicemail_txt_to_speech: "Je ne suis pas disponible, laissez-moi un message et je vous rappellerai rapidement."
        },
        subscription: {
            datasource: "demo-dataset",
            id_plan: "lf-monthly-performance",
            messages_counters: {
                backoffice: {
                    assistant: {
                        read: 0,
                        unread: 0
                    },
                    user: {
                        read: 0,
                        unread: 0
                    }
                },
                frontend: {
                    assistant: {
                        read: 0,
                        unread: 0
                    },
                    user: {
                        read: 0,
                        unread: 0
                    }
                }
            },
            name: "Demo Subscription",
            network: "",
            opening: {
                days: "weekdays",
                hours: [
                    "10",
                    "19"
                ]
            },
            paused_at: null,
            sender: [
                "33611223344"
            ],
            settings: {
                beta_account: false,
                demo_account: true,
                email_notification_copy: [],
                payg_enabled: false,
                payment_wall: false
            },
            status: "ready",
            timezone: {
                city: "paris",
                continent: "europe",
                country: "france"
            }
        },
        ai: {
            domain: "domain-8F28730C7D",
        },
        contacts: [],
        calls: [],
        sms: [],
        voicemails: [],
        tasks: []
    },
    script: ""
}

export const DEMO_FIRSTNAMES = [
    "Thomas", "Léa", "Lucas", "Manon", "Hugo", "Emma", "Nathan", "Chloé", "Enzo", "Camille",
    "Louis", "Sarah", "Gabriel", "Inès", "Jules", "Clara", "Arthur", "Alice", "Mathéo", "Louna",
    "Antoine", "Juliette", "Nicolas", "Eva", "Julien", "Marine", "Pierre", "Lucie", "Maxime", "Lise",
    "Alexandre", "Victoire", "Quentin", "Agathe", "Romain", "Noémie", "Florian", "Charlotte", "Bastien", "Amandine",
    "Théo", "Mathilde", "Cédric", "Élodie", "Guillaume", "Mélanie", "Aurélien", "Margaux", "Damien", "Louise"
];

export const DEMO_LASTNAMES = [
    "Martin", "Bernard", "Thomas", "Petit", "Robert", "Richard", "Durand", "Dubois", "Moreau", "Laurent",
    "Simon", "Michel", "Lefebvre", "Leroy", "Roux", "David", "Bertrand", "Morel", "Fournier", "Girard",
    "Bonnet", "Dupont", "Lambert", "Fontaine", "Rousseau", "Vincent", "Muller", "Lefevre", "Faure", "Andre",
    "Mercier", "Blanc", "Guerin", "Boyer", "Garnier", "Chevalier", "Francois", "Legrand", "Gauthier", "Garcia",
    "Perrin", "Robin", "Clement", "Morin", "Nicolas", "Henry", "Roussel", "Mathieu", "Gautier", "Masson"
];

export const DEMO_DOMAINS = [
    "leedflow.com",
    "gmail.com",
    "outlook.fr",
    "orange.fr",
    "sfr.fr",
    "free.fr",
    "hotmail.com",
    "yahoo.fr",
    "laposte.net",
    "wanadoo.fr",
    "icloud.com"
];
